var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "24px",
    height: "24px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M24 9.5c3.09 0 5.41 1.34 6.65 2.45l4.88-4.88C32.32 4.91 28.47 3 24 3 14.61 3 7.02 9.79 5.11 18.41l5.86 4.54C12.68 15.29 17.9 9.5 24 9.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M43.63 24.55c0-.7-.06-1.38-.16-2.04H24v7.15h11.06c-.46 2.35-1.82 4.34-3.86 5.67l5.96 4.62c3.48-3.2 5.47-7.92 5.47-13.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC05",
    d: "M12.28 26.41c-.44-1.28-.69-2.64-.69-4.04s.25-2.76.69-4.04l-5.86-4.54C4.62 17.05 3.5 20.42 3.5 24s1.12 6.95 2.92 9.61l5.86-4.54z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M24 44c5.72 0 10.52-1.9 14.03-5.14l-5.96-4.62c-2.1 1.42-4.8 2.26-8.07 2.26-6.1 0-11.32-4.79-12.43-11.11l-5.86 4.54C7.02 38.21 14.61 44 24 44z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.d916ec50c6d67ea2eeec4911916b6a67.svg";
export { ForwardRef as ReactComponent };